import { exportCsv } from './helper';

/** @constant @type {import('material-table').Options}*/
export const MATERIAL_TABLE_OPTIONS = {
    actionsColumnIndex: -1, // Makes actions last column
    pageSize: 50,
    pageSizeOptions: (4)[(50, 100, 250, 500)],
    maxBodyHeight: 696,
    addRowPosition: 'first',
    cellStyle: { textAlign: 'left', wordWrap: 'break-word' },
    emptyRowsWhenPaging: false,
    paging: true,
    search: true,
    exportCsv,
};

export const statusClasses = {
    Active: '!bg-[#d8ffd8] !text-[#008c15]/90 border !border-black/25 !rounded-2xl justify-center',
    Pending:
        '!bg-[#fff4ca] !text-[#8c7700]/90 border !border-black/25 !rounded-2xl justify-center',
    Inactive:
        '!bg-[#e6e6e6] !text-[#4a4d4f]/90 border !border-black/25 !rounded-2xl justify-center',
    Ready: '!bg-[#d8f7ff] !text-[#00519E]/90 border !border-black/25 !rounded-2xl justify-center',
    Suspended:
        '!bg-[#ffd8d8] !text-[#9e0000]/90 border !border-black/25 !rounded-2xl justify-center',
};
